var console = require("./logger.js");
var CallbackTable = require("./callbacktable.js");

/*
messageObject
{
    targetId,
    messageId,
    message,
    senderId
}
*/

function MessageProxy () {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + MessageProxy.name + "][constructor] Enter");

    this._messageCallbackTable = new CallbackTable();
    this._errorCallbackTable = new CallbackTable();
    this.setTargetInfo(this._defaultTargetInfo);
}
MessageProxy.name = "MessageProxy";

MessageProxy.prototype.postMessage = function (messageId, message, senderId) {

    console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postMessage] Enter:"+messageId);

    if (messageId == null) {

        console.error(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postMessage] Empty messageId");
        return this;
    }

    if (this._isTargetInfoValid() === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][postMessage] Invalid target");
        return this;
    }

    if (senderId == null) {

        senderId = this._senderId;
    }

    var targetInfo = this.getTargetInfo();

    this._doPostMessage({
        targetId: targetInfo.targetId,
        messageId: messageId,
        message: message,
        senderId: senderId
    });

    return this;
};

MessageProxy.prototype._message = function (before, after) {};
MessageProxy.prototype._error = function (before, after) {};

MessageProxy.prototype.onMessage = function (messageId, messageCallback, context, namespace) {

    var before = this._messageCallbackTable.getCallbackCount();
    this._messageCallbackTable.addCallback(messageId, messageCallback, context, namespace, false);
    var after = this._messageCallbackTable.getCallbackCount();
    this._message(before, after);

    return this;
};

MessageProxy.prototype.oneMessage = function (messageId, messageCallback, context, namespace) {

    var before = this._messageCallbackTable.getCallbackCount();
    this._messageCallbackTable.addCallback(messageId, messageCallback, context, namespace, true);
    var after = this._messageCallbackTable.getCallbackCount();
    this._message(before, after);

    return this;
};

MessageProxy.prototype.offMessage = function (messageId, messageCallback, context, namespace) {

    var before = this._messageCallbackTable.getCallbackCount();
    this._messageCallbackTable.removeCallback(messageId, messageCallback, context, namespace);
    var after = this._messageCallbackTable.getCallbackCount();
    this._message(before, after);

    return this;
};

MessageProxy.prototype.onError = function (errorId, errorCallback, context, namespace) {

    var before = this._errorCallbackTable.getCallbackCount();
    this._errorCallbackTable.addCallback(errorId, errorCallback, context, namespace, false);
    var after = this._errorCallbackTable.getCallbackCount();
    this._error(before, after);

    return this;
};

MessageProxy.prototype.oneError = function (errorId, errorCallback, context, namespace) {

    var before = this._errorCallbackTable.getCallbackCount();
    this._errorCallbackTable.addCallback(errorId, errorCallback, context, namespace, true);
    var after = this._errorCallbackTable.getCallbackCount();
    this._error(before, after);

    return this;
};

MessageProxy.prototype.offError = function (errorId, errorCallback, context, namespace) {

    var before = this._errorCallbackTable.getCallbackCount();
    this._errorCallbackTable.removeCallback(errorId, errorCallback, context, namespace);
    var after = this._errorCallbackTable.getCallbackCount();
    this._error(before, after);

    return this;
};

MessageProxy.prototype.setSenderId = function (senderId) {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][setSenderId] Enter");
    this._senderId = senderId;

    return this;
};

MessageProxy.prototype.getSenderId = function () {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][getSenderId] Enter");
    return this._senderId;
};

MessageProxy.prototype.setTargetInfo = function (targetInfo) {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][setTargetInfo] Enter");

    if (targetInfo == null) {

        this._targetInfo = this._cloneTargetInfo(this._defaultTargetInfo);

    } else {

        this._targetInfo = this._cloneTargetInfo(targetInfo);
    }

    return this;
};

MessageProxy.prototype.getTargetInfo = function () {

    //console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][getTargetInfo] Enter");

    if (this._targetInfo == null) {

        this._targetInfo = this._cloneTargetInfo(this._defaultTargetInfo);
    }

    return this._cloneTargetInfo(this._targetInfo);
};

MessageProxy.prototype._cloneTargetInfo = function (infoSrc) {

    if (infoSrc == null) {

        return null;
    }

    return {
        targetId: infoSrc.targetId
    };
};

MessageProxy.prototype._senderId = "Message.Unknown";

MessageProxy.prototype._targetInfo = null;
MessageProxy.prototype._messageCallbackTable = null;
MessageProxy.prototype._errorCallbackTable = null;

MessageProxy.prototype._doPostMessage = function (messageObject) {};

MessageProxy.prototype._isTargetInfoValid = function () {

    var targetInfo = this.getTargetInfo();

    if (targetInfo == null ||
        targetInfo.targetId == null) {

        return false;
    }

    return true;
};

//message wrappers
MessageProxy.prototype._messageCallbackWrapper = function () {};
MessageProxy.prototype._errorCallbackWrapper = function () {};

MessageProxy.prototype._messageCallback = function () {};
MessageProxy.prototype._errorCallback = function () {};

MessageProxy.prototype._createMessageObject = function (rawMessage) {};

//message checkers
MessageProxy.prototype._isValidMessage = function (messageObject) {

    if (messageObject == null ||
        messageObject.targetId == null ||
        messageObject.messageId == null ||
        messageObject.senderId == null ||
        messageObject.targetId !== this._senderId) {

        return false;
    }

    var targetInfo = this.getTargetInfo();

    if (messageObject.senderId !== targetInfo.targetId) {

        return false;
    }

    return true;
};

MessageProxy.prototype._errorCallbackCheck = function (errorObject) {};

MessageProxy.prototype.forwardMessage = function (messageObject) {

    console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][forwardMessage] Enter");

    if (this._isValidMessage(messageObject) === false) {

        console.warn(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][forwardMessage] Invalid message");
        return this;
    }

    this._doMessageCallback(messageObject, this);

    return this;
};

MessageProxy.prototype._doMessageCallback = function (messageObject, messageProxy) {

    var before = this._messageCallbackTable.getCallbackCount();
    var callbackArray = this._messageCallbackTable.getCallbackArray(messageObject.messageId);
    var after = this._messageCallbackTable.getCallbackCount();
    // for oneMessage callback, which decrease the count during getCallbackArray()
    this._message(before, after);

    if (callbackArray.length > 0) {

        console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_doMessageCallback] messageId: " + messageObject.messageId);
    }

    this._doCallback(callbackArray, messageObject, messageProxy);
};

MessageProxy.prototype._doErrorCallback = function (errorObject, messageProxy) {

    var before = this._errorCallbackTable.getCallbackCount();
    var callbackArray = this._errorCallbackTable.getCallbackArray(errorObject.errorId);
    var after = this._errorCallbackTable.getCallbackCount();
    // for oneError callback, which decrease the count during getCallbackArray()
    this._error(before, after);

    if (callbackArray.length > 0) {

        console.log(__GLOBAL_LOG_PREFIX__, "[" + this.constructor.name + "][_doErrorCallback] errorId: " + errorObject.errorId);
    }

    this._doCallback(callbackArray, errorObject, messageProxy);
};

MessageProxy.prototype._doCallback = function (callbackArray, object, messageProxy) {

    for (var i = 0; i < callbackArray.length; i++) {

        var callbackObject = callbackArray[i];

        if (callbackObject.context == null) {

            callbackObject.callback(object, messageProxy);

        } else {

            callbackObject.callback.call(callbackObject.context, object, messageProxy);
        }
    }
};

MessageProxy.prototype._defaultTargetInfo = {
    targetId: null
};

MessageProxy.prototype.getTargetType = function () {

    return this._targetType;
};

MessageProxy.prototype._targetType = "";

MessageProxy.prototype.hasSameTarget = function (messageProxy) {

    if (this === messageProxy) {

        return true;
    }

    if (this.getTargetType() !== messageProxy.getTargetType()) {

        return false;
    }

    return this._targetInfoCheck(messageProxy);
};

MessageProxy.prototype._targetInfoCheck = function (messageProxy) {

    var myTargetInfo = this.getTargetInfo();
    var targetInfo = messageProxy.getTargetInfo();

    if (myTargetInfo.targetId === targetInfo.targetId) {

        return true;
    }

    return false;
};



module.exports = MessageProxy;